export default function setWeight(variant) {
    if (!variant) {
        return 'normal';
    }

    const weight = variant.replace(/\D/g, '');
    if (weight === '') {
        return 'normal';
    }

    return weight;
}
